import React, {useEffect, useState} from 'react';

import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

import FullScreenDialog from "./FullScreenDIalog";
import {useDispatch, useSelector} from "react-redux";
import {getOSPorEtapaMaquinaCiclo} from "../../../actions/autoclaveActions";



const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};



const  AutoclaveLotarOSTabela = ( props )  => {

    const { autoclaveId, autoclaveCodigo, ciclo } = props;

    const AutoclaveCicloOSs = useSelector(state => state.autoclaves.AutoclaveCicloOSs);

      const [ selectedRow, setSelectedRow] = useState (null);
      const [ isAddNewRecord, setIsAddNewRecord] = useState(false);
      const [ isOpen, setIsOpen] = useState(false);
      const [ numLinhas, setNumLinhas] = useState(5);
      const dispatch = useDispatch();

      useEffect(() => {

        dispatch(getOSPorEtapaMaquinaCiclo(22,autoclaveCodigo, ciclo));
      }, [autoclaveCodigo, ciclo]);

      useEffect(() => {
          console.log("AutoclaveCicloOSs length", AutoclaveCicloOSs.length);
          setNumLinhas(AutoclaveCicloOSs.length === 0? 3 : AutoclaveCicloOSs.length + 1);
      }, [AutoclaveCicloOSs]);


   const getColumns = () => {
        return [
            {
                title: 'id',
                field: 'id',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Posição',
                field: 'maquinaPosicao',
                editable: 'never',
            },
            {
                title: 'Ordem Serviço',
                field: 'os',
                editable: 'never',
            },
            {
                title: 'Fabricante',
                field: 'fabricante',
                editable: 'never'
            },

            {
                title: 'Modelo',
                field: 'modelo',
                editable: 'never'
            },
            {
                title: 'Medida',
                field: 'medida',
                editable: 'never'
            },
            {
                title: 'Vida',
                field: 'serviceOrderStep.serviceOrder.vida',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Banda',
                field: 'banda',
                editable: 'never'
            },
            {
                title: 'Envelope',
                field: 'envelope',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Inner',
                field: 'inner',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Saco ar',
                field: 'sacoDeAr',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Descricao',
                field: 'descricao',
                editable: 'never',
                hidden: true
            },
            {
                title: 'Largura Banda',
                field: 'isEnrollmentClosed',
                editable: 'never',
                hidden: true
            },


        ];
    }

  const openDialog = (e, newRow, data) => {
        console.log("openDialog", newRow, data)

        setIsAddNewRecord(newRow? newRow : false);
        setIsOpen(true);
        setSelectedRow(data);

  };

   const closeDialog = () => {
       setIsOpen(false);
       setSelectedRow(null);
       dispatch(getOSPorEtapaMaquinaCiclo(22,autoclaveCodigo, ciclo));
  };




        const titulo = `Vulcanização`; // ${ciclo.autoclave.Codigo} - ${ciclo.Ciclo} de ${convertISODateTimeToBRLocale(ciclo.DTInicio)}- Ordens de Serviço`;


        let psO = [ numLinhas, 5, 10, 16, 20, 25];

        const options = {
            filtering: true,
            pageSize: numLinhas,
            pageSizeOptions: psO,
            addRowPosition: 'first'
        }



        return (
            <div>


                        <MaterialTable
                            icons={tableIcons}
                            title={titulo}
                            columns={getColumns()}
                            data={AutoclaveCicloOSs}
                            options={options}

                            actions={[
                                {
                                    icon: 'add',
                                    tooltip: 'Nova Ordem de Serviço',
                                    isFreeAction: true,
                                    onClick: (event) => { openDialog(event, true); }
                                }
                            ]}

                            onRowClick={ (e, data) => {
                              //  console.log("row click", e);
                              //  console.log("row click data", data);
                                openDialog(e, false, data)
                            }}



                        />
                <FullScreenDialog isOpen={isOpen} autoclaveCodigo={autoclaveCodigo}
                                   ciclo={ciclo} cicloDetalhes={AutoclaveCicloOSs} addNewRecord={isAddNewRecord}
                                  selectedRow={selectedRow} closeDialog={closeDialog}/>

            </div>
        )


}



export default AutoclaveLotarOSTabela

